<script setup lang="ts">
import type { Schemas } from "#shopware";
import {
  getCategoryRoute,
  getTranslatedProperty,
} from "@shopware/helpers";

const { navigationElement } = defineProps<{
  navigationElement: Schemas["Category"];
}>();

const dropdown = ref();
const isDropdownVisible = ref(false);

function toggleDropdown(state: boolean) {
  if (!navigationElement.childCount) {
    return;
  }

  isDropdownVisible.value = state;
}

watch(useRoute(), (newRoute) => {
  isDropdownVisible.value = false;
});

const backgroundColor = computed<string>(() => navigationElement?.translated?.customFields?.category_name_background_color || '#ffffff')
const textColor = computed<string>(() => navigationElement?.translated?.customFields?.category_name_text_color || '#344854')
</script>

<template>
  <li
    class="flex justify-center items-center py-4 first:-ml-4 group"
    @mouseenter="toggleDropdown(true)"
    @mouseleave="toggleDropdown(false)"
  >
    <NuxtLink
      :to="getCategoryRoute(navigationElement)"
      class="py-2 px-4 rounded-full text-pretty hover:bg-primary-50 transition-colors"
      :class="[`bg-[${backgroundColor}]`, `text-[${textColor}]`]"
    >
      {{ getTranslatedProperty(navigationElement, "name") }}
    </NuxtLink>

    <ul
      v-if="navigationElement?.childCount && isDropdownVisible"
      ref="dropdown"
      class="hidden group-hover:grid grid-cols-5 gap-4 container py-6 animate-fadein absolute top-full left-0 right-0 rounded-b-lg shadow bg-white dark:bg-gray-900 z-20"
    >
      <li v-for="child in navigationElement?.children" :key="child.id">
        <NuxtLink :to="getCategoryRoute(child)" class="font-semibold text-xl">
          {{ getTranslatedProperty(child, "name") }}
        </NuxtLink>

        <ul class="flex flex-col gap-y-4 mt-6">
          <li v-for="grandchild in child?.children" :key="grandchild.id">
            <NuxtLink
              :to="getCategoryRoute(grandchild)"
              class="text-pretty hover:underline transition"
            >
              {{ getTranslatedProperty(grandchild, "name") }}
            </NuxtLink>
          </li>
        </ul>
      </li>
    </ul>
  </li>

  <div
    v-if="isDropdownVisible"
    class="backdrop-blur-md bg-transparent w-dvw min-h-dvh h-full animate-fadein absolute top-full left-0 right-0 z-10"
  ></div>
</template>
